import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { environmentURLs } from '../../../components/common/environment/CaptureEnvironment';
import axios from 'axios';
export const initialState = {
  data: {
    verified: false,
    reloadPyamentSetting: false,
    paymentSettingData: [],
    otherPaymentOption: false,
    paymentDetails: {},
    paymentHistoryData : [],
    loading: false,
    previousRoute: ''
  }
};
export const getPaymentSetting = createAsyncThunk(
  'getPaymentSetting',
  async ({ email, countryCode, token }) => {
    const endpoint = `${environmentURLs.marketplaceURL}graphql`;
    const headers = {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`
    };
    const graphqlQuery = {
      query: `
       query($emailId: String,$countryCode: String) {
       getPaymentSettingData(emailId: $emailId,countryCode:$countryCode) {
       customer_login_email
       payment_type
       customer_reference
       payment_type_reference
       status
       last4
       country
      }
    }`,
      fetchPolicy: 'no-cache',
      variables: { emailId: email, countryCode }
    };

    const response = await axios({
      url: endpoint,
      method: 'post',
      headers: headers,
      data: graphqlQuery
    });
    return response.data.data.getPaymentSettingData;
  }
);

export const getAppPaymentHistory = createAsyncThunk(
  'getAppPaymentHistory',
  async ({ solnId, startDate, endDate, token }) => {
    const endpoint = `${environmentURLs.marketplaceURL}graphql`;
    const headers = {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`
    };
    const graphqlQuery = {
      query: `
        query($solnId: String, $startDate: String, $endDate: String) {
        getAppPaymentHistory(
          solnId: $solnId
          startDate: $startDate
          endDate: $endDate
        ) {
          app_name
          customer_org_name
          totalcharge
          fortellisfee
          balancetotal
          plan_name
          created
          order_total_amount
          taxable_amount
          tax_rate
          tax_paid
          modified_by_user_email
          modified_by_user_login
          remittance_org_id
          receipt_url
          invoice_reference
          invoice_url
          status
          gst_tax_amount
          pst_tax_amount
          qst_tax_amount
          currency
          product_type
          last4
          payment_type
        }
      }
      `,
      fetchPolicy: 'no-cache',
      variables: { solnId, startDate, endDate }
    };

    const response = await axios({
      url: endpoint,
      method: 'post',
      headers: headers,
      data: graphqlQuery
    });
    return response.data.data.getAppPaymentHistory;
  }
);

const verifyAccountSlice = createSlice({
  name: 'verifyAccount',
  initialState: initialState,
  reducers: {
    verifyAccount: (state, action) => {
      state.data.verified = action.payload;
    },
    reloadPaymentSettingData: (state, action) => {
      state.data.reloadPyamentSetting = action.payload;
    },
    otherPaymentOptionRequest: (state, action) => {
      state.data.otherPaymentOption = action.payload;
    },
    resetOtherPaymentOption: (state, action) => {
      state.data.otherPaymentOption = action.payload;
    },
    setPaymentDetails: (state, action) => {
      state.data.paymentDetails = action.payload;
    },
    setPreviousRoute: (state, action) => {
      state.data.previousRoute = action.payload;
    }
  },
  extraReducers: {
    [getPaymentSetting.fulfilled]: (state, action) => {
      const results = action.payload;
      state.data.paymentSettingData = results;
      state.data.loading = false;
    },
    [getPaymentSetting.pending]: state => {
      state.data.paymentSettingData = [];
      state.data.loading = true;
    },
    [getPaymentSetting.rejected]: state => {
      state.data.paymentSettingData = [];
    },
    [getAppPaymentHistory.fulfilled]: (state, action) => {
      const results = action.payload;
      state.data.paymentHistoryData = results;
      state.data.loading = false;
    },
    [getAppPaymentHistory.pending]: state => {
      state.data.paymentHistoryData = [];
      state.data.loading = true;
    },
    [getAppPaymentHistory.rejected]: state => {
      state.data.paymentHistoryData = [];
    }
  }
});

export const {
  verifyAccount,
  reloadPaymentSettingData,
  otherPaymentOptionRequest,
  resetOtherPaymentOption,
  setPaymentDetails,
  setPreviousRoute
} = verifyAccountSlice.actions;

export default verifyAccountSlice.reducer;
